import {Injectable, Injector} from "@angular/core";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {UserProfileSummaryData} from "./user-profile-summary.data";

/**
 * Logged in User Profile summary information
 */

@Injectable()
export class UserProfileSummaryEntityModel extends EntityModel<UserProfileSummaryData> {

    constructor(injector: Injector) {
        super(injector, UserProfileSummaryData);
    }
}
